"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _Link = _interopRequireDefault(require("../../../core/Link"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)(_Link.default, process.env.NODE_ENV === "production" ? {
  target: "e1s7qlfe0"
} : {
  target: "e1s7qlfe0",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("width:auto;border-bottom:1px solid ", props.color, ";border-radius:0;padding-bottom:0.25em;margin-bottom:1em;overflow:hidden;white-space:nowrap;&>span{display:flex;align-items:center;width:100%;text-align:left;line-height:24px;font-weight:normal;& svg{margin-right:10px;}}text-decoration:none;&:focus-visible{text-decoration:underline;}&:hover{border-bottom:1px solid ", props.color, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));